import React from 'react';
import PropTypes from 'prop-types';

import {
  Manager,
  Target,
} from 'react-popper';
import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import messages from './messages';

const EnrollmentsButton = ({ children, ...props }) => (
  <Manager>
    <Target>
      <Button primary {...props}>
        <MaterialIcon id="add" left />
        {intl.formatMessage(messages.enrollStudents)}
      </Button>
    </Target>
    {children}
  </Manager>
);

EnrollmentsButton.propTypes = {
  children: PropTypes.any,
};

export default EnrollmentsButton;
